import { Controller } from "@hotwired/stimulus"

// ปุ่มแนบสลิป — input จริงถูกซ่อน (sr-only) โชว์ชื่อไฟล์ที่เลือกแทน "Choose File" ของ browser
export default class extends Controller {
  static targets = ["input", "filename"]

  changed() {
    const file = this.inputTarget.files[0]
    this.filenameTarget.textContent = file ? this.filenameTarget.dataset.template.replace("%{name}", file.name) : ""
    this.filenameTarget.classList.toggle("hidden", !file)
  }
}
